import { useState, useEffect } from 'react';
import api from '../services/api';

const STATUT_CONFIG = {
    nouveau:   { label: 'Nouveau',   color: '#ef4444', bg: '#fee2e2', border: '#ef4444', icon: 'ti-alert-circle' },
    en_cours:  { label: 'En cours',  color: '#d97706', bg: '#fef3c7', border: '#f59e0b', icon: 'ti-clock' },
    resolu:    { label: 'Résolu',    color: '#16a34a', bg: '#dcfce7', border: '#22c55e', icon: 'ti-check' },
};

export default function BugReportsPage() {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadReports = () => {
        api.get('/bug_reports?pagination=false&order[createdAt]=desc')
            .then(res => {
                const reports = (res.data.member || []).sort((a, b) =>
                    new Date(b.createdAt) - new Date(a.createdAt)
                );
                setReports(reports);
                // Marquer comme lu par admin
                localStorage.setItem('bug_reports_last_visit', new Date().toISOString());
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadReports();
    }, []);

    const handleStatut = async (report, newStatut) => {
        try {
            await api.patch(`/bug_reports/${report.id}`, {
                statut: newStatut,
                luParAdminAt: new Date().toISOString(),
            }, { headers: { 'Content-Type': 'application/merge-patch+json' } });
            loadReports();
        } catch (err) {
            console.error(err);
        }
    };

    if (loading) return <div style={{ padding: '24px', color: '#888' }}>Chargement...</div>;

    return (
        <div style={{ padding: '24px', maxWidth: '800px' }}>
            <h2 style={{ margin: '0 0 24px', fontSize: '22px', fontWeight: '700', color: 'var(--text-main)' }}>
                <i className="ti ti-bug" style={{ marginRight: '8px' }} />
                Rapports de bugs ({reports.length})
            </h2>

            {reports.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                    <i className="ti ti-check" style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }} />
                    Aucun bug signalé
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {reports.map(r => {
                        const statutCfg = STATUT_CONFIG[r.statut] || STATUT_CONFIG.nouveau;
                        return (
                            <div key={r.id} style={{
                                backgroundColor: 'var(--card-bg)',
                                borderRadius: '12px',
                                padding: '16px 20px',
                                boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
                                borderLeft: `4px solid ${statutCfg.border}`,
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <span style={{ fontWeight: '700', fontSize: '14px', color: 'var(--text-main)' }}>
                                        <i className="ti ti-user" style={{ marginRight: '6px' }} />
                                        {r.auteur}
                                    </span>
                                    <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                                        <i className="ti ti-clock" style={{ marginRight: '4px' }} />
                                        {new Date(r.createdAt).toLocaleString('fr-FR')}
                                    </span>
                                </div>

                                <div style={{ fontSize: '14px', color: 'var(--text-main)', whiteSpace: 'pre-wrap', marginBottom: '14px' }}>
                                    {r.message}
                                </div>

                                {/* Boutons statut */}
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    {Object.entries(STATUT_CONFIG).map(([key, cfg]) => (
                                        <button
                                            key={key}
                                            onClick={() => handleStatut(r, key)}
                                            style={{
                                                padding: '4px 12px',
                                                borderRadius: '20px',
                                                border: `1.5px solid ${r.statut === key ? cfg.border : '#e0e0e0'}`,
                                                backgroundColor: r.statut === key ? cfg.bg : 'transparent',
                                                color: r.statut === key ? cfg.color : '#888',
                                                fontSize: '12px',
                                                fontWeight: r.statut === key ? '700' : '400',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <i className={`ti ${cfg.icon}`} style={{ marginRight: '4px' }} />
                                            {cfg.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}